/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : authentication.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import actionType from "../actionTypes";
const authenticationApis = {
  login: {
    api_name: "/UCM/user/login",
    https_method: "POST",
    action_type: actionType.LOGIN,
    description: "",
  },
  forgot_password: {
    api_name: "/UCM/user/reset/password/otp",
    https_method: "POST",
    action_type: actionType.FORGOT_PASSWORD,
    description: "",
  },
  reset_password: {
    api_name: "/UCM/user/reset/password/update",
    https_method: "PUT",
    action_type: actionType.RESET_PASSWORD,
    description: "",
  },
};

export default authenticationApis;
